import type { KeyboardEvent, MouseEvent, SyntheticEvent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Link } from '../../../../Link'
import { TypographyV2 } from '../../../../Seatbelt2/Foundations/Typography'
import styles from './ProductCardPrice.module.scss'

export const ProductCardPrice = ({
  className,
  priceClassName,
  price,
  retailers,
  slug,
  productUrl,
  manufacturer,
  model,
  viewRetailersCallback,
}: Props) => (
  <TypographyV2
    tag="span"
    textStyle="sb-text-body-default-strong"
    className={className}
    data-testid="product-price-information"
  >
    <span className={classnames(styles.price, priceClassName)}>{price}</span>
    {retailers ? (
      <Link
        id={slug}
        onClick={(e: MouseEvent) => {
          e.stopPropagation()
          viewRetailersCallback && viewRetailersCallback(e)
        }}
        onKeyDown={(e: KeyboardEvent) => {
          e.stopPropagation()
          e.key === 'Enter' && viewRetailersCallback && viewRetailersCallback(e)
        }}
        href={`${productUrl.match(/\/reviews.*/)?.[0]}#compare-prices`}
        textStyle="sb-text-interface-body-small-strong"
        className={classnames(styles.label, styles.retailers)}
        data-url={`View product retailers at this URL: (${productUrl}#compare-prices)`}
        data-testid="view-retailers-link"
        data-which-id="supply-offers-link"
        aria-label={`View retailers where you can buy ${manufacturer} ${model}`}
      >
        View retailers
      </Link>
    ) : (
      <TypographyV2
        tag="span"
        className={styles.label}
        textStyle="sb-text-body-small-regular"
      >
        Typical price
      </TypographyV2>
    )}
  </TypographyV2>
)

type Props = {
  className?: string
  priceClassName?: string
  price: string
  productUrl: string
  retailers?: boolean
  slug: string
  manufacturer: string
  model: string
  viewRetailersCallback?: (e: SyntheticEvent) => void
}
